/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/lib/lodash.js"/>

(function($, _) {
  "use strict";

  var ns = nspace("ccc.indicatorSelection");
  ns.IndicatorSelectionCheckboxView = Backbone.View.extend({
    initialize: function() {
      var self = this,
        indicators = self.model.get("selectedIndicators").split(","),
        selectedCategories;

      _.bindAll(this, "render");

      this.model.on("change", this.render);

      // change the selectedCategories of the model
      // if the category isn't initially expanded
      if (self.model.get("selectedIndicators").length > 0) {
        selectedCategories = self.model.get("selectedCategories");
        // get the selected categories of each checkbox
        _.each(indicators, function(indicator) {
          // get the selected category
          var parentId = $("#indicator-" + indicator).attr("indicator");
          if (
            _.has(selectedCategories, parentId) === false &&
            typeof parentId !== "undefined"
          ) {
            selectedCategories[parentId] = true;
            self.model.set("selectedCategories", selectedCategories);
          }
        });
      }

      /**
       * Sets the model's selectedIndicators given an array of indicators to add or remove.
       * @param indicatorArray An array of indicators to add or remove.
       * @param willCheck True to add, false to remove the specified indicators.
       */
      function setSelectedIndicators(indicatorArray, willCheck) {
        var allIndicators = self.model.get("selectedIndicators").split(","),
          newIndicators;

        _.each(indicatorArray, function(indicator) {
          if (
            willCheck === true &&
            _.contains(allIndicators, indicator) === false
          ) {
            allIndicators.push(indicator);
          }
          else if (willCheck === false) {
            allIndicators = _(allIndicators).reject(function(el) {
              return el === indicator;
            });
          }
        });

        allIndicators.sort(function(a, b) {
          return a - b;
        });

        newIndicators = allIndicators.join(",");
        if (newIndicators === "") {
          newIndicators = "0";
        }
        if (self.model.get("selectedIndicators") !== newIndicators) {
          self.model.set("selectedIndicators", newIndicators);
        }
      }

      $(".download-subtopic-list-checkbox").on("click", function() {
        setSelectedIndicators(
          [
            $(this)
              .attr("id")
              .replace("indicator-", "")
          ],
          $(this).prop("checked")
        );
      });

      $(".download-subcategory, .download-category").on("click", function() {
        var newIndicators = [];
        $(this)
          .parent("li")
          .find(".download-subtopic-list-checkbox")
          .each(function() {
            newIndicators.push(
              $(this)
                .attr("id")
                .replace("indicator-", "")
            );
          });

        setSelectedIndicators(newIndicators, $(this).prop("checked"));
      });
    },

    /**
     * Checks the checkboxes, as well as parent checkboxes
     */
    render: function() {
      var self = this,
        indicators = self.model.get("selectedIndicators").split(","),
        columns = [
          ".download-indicator-list-left",
          ".download-indicator-list-right"
        ];

      // get the hierarchy of tabs
      _.each(columns, function(column) {
        // get the top level categories
        $(column)
          .children("li")
          .each(function() {
            var $topLevelCategory = $(this),
              $subCategories = $topLevelCategory
                .find(".indicator-subtopics-list")
                .children("li"),
              $orphanCheckboxes = $topLevelCategory
                .find(".download-indicator-list-toggle-container")
                .children(".download-subtopic-list")
                .find(".download-subtopic-list-checkbox"),
              counter = 0,
              $topLevelCategoryCheckBox = $topLevelCategory.children(
                "input.download-category"
              );

            // get any sub categories
            $subCategories.each(function() {
              var $subCategory = $(this),
                $checkBoxes = $subCategory.find(
                  ".download-subtopic-list-checkbox"
                ),
                subCounter = 0,
                $subCategoryCheckBox = $subCategory.children(
                  "input.download-subcategory"
                );

              // check the applicable checkboxes
              $checkBoxes.each(function() {
                var id = $(this)
                    .attr("id")
                    .replace("indicator-", ""),
                  isIn = _.contains(indicators, id);
                if ($(this).prop("checked") !== isIn) {
                  $(this).prop("checked", isIn);
                }

                // count the number of checked in outer var
                if ($(this).prop("checked") === true) {
                  subCounter++;
                }
              });

              // check the applicable subcategory checkboxes
              $subCategoryCheckBox.each(function() {
                if (
                  $(this).prop("checked") !==
                  (subCounter === $checkBoxes.length)
                ) {
                  $(this).prop("checked", subCounter === $checkBoxes.length);
                }
                // count the number of subcategory checked in outer var
                if ($(this).prop("checked") === true) {
                  counter++;
                }
              });
            });

            // check the applicable orphaned checkboxes
            $orphanCheckboxes.each(function() {
              var id = $(this)
                  .attr("id")
                  .replace("indicator-", ""),
                isIn = _.contains(indicators, id);
              if ($(this).prop("checked") !== isIn) {
                $(this).prop("checked", isIn);
              }

              // count the number of checked in outer var
              if ($(this).prop("checked") === true) {
                counter++;
              }
            });

            // check the applicable top level category checkboxes
            $topLevelCategoryCheckBox.each(function() {
              if (
                $(this).prop("checked") !==
                (counter === $subCategories.length + $orphanCheckboxes.length)
              ) {
                // check the top level category checkbox
                $(this).prop(
                  "checked",
                  counter === $subCategories.length + $orphanCheckboxes.length
                );
              }
            });
          });
      });
    }
  });
})(jQuery, _);
